import React from "react";
import PropTypes from "prop-types";
import "./badge.scss";
import classnames from "classnames";

const Badge = ({ number, className, ...props }) => {
  const value = number > 98 ? "99+" : number;
  const classes = classnames("badge", className);

  return (
    <span className={classes} {...props}>
      {value || " "}
    </span>
  );
};

Badge.propTypes = {
  /**
   * Number to display.
   */
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Custom className to add to the component
   */
  className: PropTypes.string,
};

export default Badge;
